<div class="video_cont">
 <div class="video_box">
  <video #webcam class="video" autoplay playsinline></video>
  <canvas #output_canvas class="output_canvas"></canvas>
  <div class="upload-container" *ngIf="sessionService.session?.user?.isAdmin">
    <input
      type="file"
      #fileInput
      accept="image/*"
      (change)="handleFileUpload($event)"
      class="file-input"
      id="fileInput"
    />
    <label for="fileInput" class="upload-button">
      <mat-icon>upload</mat-icon>
      {{ 'cameraErrors.uploadImage' | translate }}
    </label>
  </div>
 </div>

  <!-- The never-stuck escape hatch ("Continue anyway") is rendered by the host
       (test.component) in the grid row below the camera, so it never moves
       the camera box. State + handler live here (showContinueAnyway,
       continueWarningKey, continueAnyway). -->
</div>
